<template>
    <div id="m_aside_left" class="m-grid__item	m-aside-left  m-aside-left--skin-dark " >
        <div id="m_ver_menu" class="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark " m-menu-vertical="1" m-menu-scrollable="0" m-menu-dropdown-timeout="500">
            <div class="m-menu__nav">
                <ul class="menu-sections">
                    <router-link class="m-menu__section" tag="li" :to="{name:'Dashboard'}" exact>
                        <h4 class="m-menu__section-text"><a>
                          <span class="decorator"><i class="fas fa-tachometer-alt"></i></span>
                          Dashboard  </a></h4>
                    </router-link>
                    <router-link class="m-menu__section" tag="li" :to="{name:'LibraryTracks'}">
                        <h4 class="m-menu__section-text"><a><span class="decorator"><i class="fas fa-music"></i></span>Library</a>
                        <span style="right: 30px;position: absolute;" v-if="typeof trackCount === 'number'" class="badge badge-primary badge-pill">{{trackCount}}</span>
                        </h4>
                    </router-link>
                    <router-link class="m-menu__section" tag="li" :to="{name:'BoxesHome'}">
                        <h4 class="m-menu__section-text"><a><span class="decorator"><i class="fas fa-box-open"></i></span>Boxes</a></h4>
                    </router-link>
                    <router-link class="m-menu__section" tag="li" :to="{name:'ClocksHome'}">
                        <h4 class="m-menu__section-text"><a><span class="decorator"><i class="far fa-clock"></i></span>Clocks</a></h4>
                    </router-link>
                    <router-link class="m-menu__section" tag="li" :to="{name:'DayTemplatesHome'}">
                        <h4 class="m-menu__section-text"><a><span class="decorator"><i class="far fa-calendar-check"></i></span>Templates</a></h4>
                    </router-link>
<!--                    <router-link class="m-menu__section" tag="li" :to="{name:'WeekTemplatesHome'}">-->
<!--                      <h4 class="m-menu__section-text"><a><span class="decorator"><i class="far fa-calendar"></i></span>Week Template</a></h4>-->
<!--                    </router-link>-->
                    <router-link class="m-menu__section" tag="li" :to="{name:'PlanningHome'}">
                        <h4 class="m-menu__section-text"><a><span class="decorator"><i class="far fa-calendar-alt"></i></span> Planning</a></h4>
                    </router-link>
                </ul>

                <router-view name="menu"></router-view>
              <div v-bind:style="{position: currentRouteName === 'PlanningHome'  ||
              currentRouteName === 'WeekTemplatesHome' ||
              currentRouteName === 'TrackHome' ||
              currentRouteName === 'TrackMix' ||
              currentRouteName === 'TrackBranding' ||
              currentRouteName === 'TrackCharts' ||
              currentRouteName === 'reportUpload' ||
              currentRouteName === 'multiSearchList' ||
              currentRouteName === 'TrackLinkBoxes' ||
              currentRouteName === 'TrackConstrains'

               ? 'fixed' : 'relative'}"
                   style=" bottom: -2px; left: 0;"  v-if=" currentRouteName !== 'Dashboard'" >
               <div style="position: absolute;
                          top: -13px;
                          left: 10px;"  >
                 <span v-if="!showSpeedometer" v-on:click.prevent="displaySpeedometre(true)"><i class="fas fa-chevron-right"></i></span>
                 <span v-if="showSpeedometer" v-on:click.prevent="displaySpeedometre(false)"><i class="fas fa-chevron-down"></i></span>
               </div>
                <hr>

                <vue-speedometer v-if="showSpeedometer" style=""
                                 :width="270"
                                 :height="170"
                                 :needleHeightRatio="0.7"
                                 :value="highlights.gauge.totalSizeMbCalcul"
                                 :segments="3"
                                 :customSegmentStops="[0, 500, 750, 1000]"
                                 :customSegmentLabels='[
                              {
                                text: "Good",
                                position: "OUTSIDE",
                                color: "limegreen",
                              },
                              {
                                text: "Warning",
                                position: "OUTSIDE",
                                color: "gold",
                              },
                              {
                                text: "Too much",
                                position: "OUTSIDE",
                                color: "red",
                              },
                            ]'
                                 :segmentColors='["limegreen",  "gold", "red"]'
                                 :ringWidth="47"
                                 :needleTransitionDuration="3333"
                                 needleTransition="easeElastic"
                                 needleColor="#000000"
                                 textColor="#000000"
                                 :currentValueText="` `+ highlights.gauge.totalSizeMb +` MB`"
                                 labelFontSize="15px"
                                 valueTextFontSize="20px"
                /></div>
            </div>
        </div>
    </div>
</template>
<script>
    import router from '@/router/index';
    import store from '@/store/index';
    import { mapState, mapActions } from 'vuex';
    import {HTTP} from "@/utils/http";
    import Apis from "@/apis";
    import EventBus from "@/eventbus";
    import VueSpeedometer from "vue-speedometer"
    // import {version} from '../../package'
    export default {
        components:{VueSpeedometer},
        name: 'LeftMenu',
        router,
        data () {
          return {
           // appVersion:version,
            gauge: {label: "Next content update", count: null, size: null, newSongsCount: 0, totalSizeMb: 0 , loading:false},
            trackCount: String,
            showSpeedometer:false,
            typeId: {
              1: "Music tracks",
              2: "Jingle",
              5: "Podcast"
            }
          }
        },
      mounted () {
        this.loadStats();
       // if(this.$route.name === 'PlanningHome'){
          this.loadGaugeData();
       // }
        if(localStorage.getItem('showSpeedometer') !== null){
          this.showSpeedometer = ( localStorage.getItem('showSpeedometer')=== 'true');
        }else{
          this.showSpeedometer = true;
        }
        EventBus.$on('reFreshLeftMenu', this.loadStats);
      },
        computed: {
          currentRouteName() {
            return this.$route.name;
          },
            ...mapState({
                isLoadingStations: state => state.loadingStates.isLoadingStations,
                currentStation: state => state.currentStation,
                userStations: state => state.stations
            }),
          highlights() {
            return {
              gauge: {label: "Next content update", count: null, size: null, newSongsCount: 0, totalSizeMb: 0 , loading:false}
            }
          },

        },
      watch: {
        "currentStation": function (val) {
          this.loadStats();
          this.cleanCache();
        },
        "$route" : function (val) {
          //if( val.name === 'PlanningHome')
          //{
            this.loadGaugeData();
          //}
    }
      },
        methods: {
          displaySpeedometre(value){
            localStorage.setItem('showSpeedometer', value)
            this.showSpeedometer = value;
          },
          async loadGaugeData() {
            this.highlights.gauge.loading = false;
            HTTP.get(Apis.station.contentUpdate, {
              params: {
                stationUid: this.$route.params.stationUid,
              }
            })
                .then(({data}) => {
                  this.highlights.gauge = data.dataItem;
                  this.updateDataGauge();
                })

          },
          updateDataGauge() {
            if (this.highlights.gauge.totalSizeMb >= 0 && this.highlights.gauge.totalSizeMb < 500) {
              this.highlights.gauge.totalSizeMbCalcul = this.highlights.gauge.totalSizeMb;
            }
            if (this.highlights.gauge.totalSizeMb >= 500 && this.highlights.gauge.totalSizeMb < 600) {
              this.highlights.gauge.totalSizeMbCalcul = ((this.highlights.gauge.totalSizeMb - 500) * 2.5) + 500;
            }
            if (this.highlights.gauge.totalSizeMb >= 600 && this.highlights.gauge.totalSizeMb < 700) {
              this.highlights.gauge.totalSizeMbCalcul = 750 + (250 / (100 / (this.highlights.gauge.totalSizeMb - 600)));
            }
            if (this.highlights.gauge.totalSizeMb >= 700) {
              this.highlights.gauge.totalSizeMbCalcul = 1000
            }
            this.highlights.gauge.loading = true;
            this.$forceUpdate();
          },
            ...mapActions(['activateStation']),
          handleStatistics (data) {
            console.log("handleStatistics 1" , data)
            this.trackCount = data.count;
            console.log("handleStatistics 2")
          },
          async loadStats(refresh) {
            console.log('-------------------search')
            await HTTP.post('/api/library/tracks/search',  {
                stationUid: this.$route.params.stationUid,
                sortField:"artist",
                sortAscending:true,
                pageSize:100,
                page:1,
              }
          )
                .then((response) => {
                  this.handleStatistics(response.data.dataItem || {})
                }, (error) => {
                  console.log('error', error)
                })
                .then(() => {
                })
          },
           cleanCache () {
             console.log('++++++++++++++++++++++++++++' , process.env.VUE_APP_VERSION)
               if (!localStorage.getItem('buildVersion') || localStorage.getItem('buildVersion').replace(/"/g, '') !== process.env.VUE_APP_VERSION) {
                   localStorage.setItem('buildVersion', JSON.stringify(process.env.VUE_APP_VERSION));
                   window.location.reload(true);
           }

          },
        }
    };
</script>
<style scoped>
    a.router-link-exact-active, a.router-link-active {
        background: rgba(255,255,255,1);
    }
    .decorator {
        color:rgba(0,0,0,0.2);
    }
    .badge
    {
      margin-left: 15px;
      padding-bottom: 3px;
      padding-top: 3px;
      margin-right: 0;
      color: white;
      border-radius: 100px;
      background: grey;
      font-size: 12px;
      line-height: 1.2;
      text-align: center;
      white-space: nowrap;
    }
</style>
